<template>
    <div class="input-group with-operator">
        <b-dropdown variant="light" class="input-group-prepend" toggle-class="text-dark border-secondary">
            <template slot="button-content">
                <i class="fal mr-2" :class="selectedOperator.icon"></i>
            </template>

            <b-dropdown-item v-for="op in operators" :key="op.value" @click="selectOperator(op)">
                <i class="fas" :class="op.icon"></i> {{ op.label }}
            </b-dropdown-item>
        </b-dropdown>

        <input type="text" class="form-control"
            :value="localValue"
            @input="onInput($event.target.value)"
            @keydown="filterKeypress">

        <div class="input-group-append" v-if="hasAddonText">
            <span class="input-group-text">
                <slot name="addon-text"></slot>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        operators: { type: Array, required: true },
        value: {
            type: Object,
            default: () => ({ op: '=', value: '' })
        }
    },

    data() {
        return {
            selectedOperator: this.value.op
                ? this.operators.find(op => op.value === this.value.op) || this.operators[0]
                : this.operators[0],
            localValue: this.value.value || ''
        };
    },

    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal && typeof newVal === 'object') {
                    this.localValue = newVal.value || '';
                    this.selectedOperator = this.operators.find(op => op.value === newVal.op) || this.operators[0];
                }
            }
        }
    },

    methods: {
        selectOperator(op) {
            this.selectedOperator = op;
            this.emitChange();
        },

        onInput(val) {
            this.localValue = val.replace(',','.');
            this.emitChange();
        },

        filterKeypress(event) {
            const allowedKeys = [
                'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
            ];

            // Povoliť navigačné a kontrolné klávesy
            if (allowedKeys.includes(event.key)) {
                return;
            }

            let char = event.key;

            // Povoliť len čísla, bodku alebo čiarku
            if (!/^[0-9.,]$/.test(char)) {
                event.preventDefault();
                return;
            }

            // transformuj čiarku na bodku
            if(char === ',') {
                char = '.';
            }

            // Zabraň druhej bodke
            if (char === '.' && this.localValue.includes('.')) {
                event.preventDefault();
            }
        },

        emitChange() {
            this.$emit('input', {
                op: this.selectedOperator.value,
                value: this.localValue
            });
        }
    },

    computed: {
        hasAddonText() {
            return !!this.$scopedSlots['addon-text'];
        }
    }
};
</script>

<style lang="scss">
.input-group.with-operator {
    .dropdown-menu {
        pointer-events: auto !important;
        transition: none !important;
        transform: none !important;
        top: 34px !important;
        display: none;

        &.show {
            opacity: 1 !important;
            display: block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/InputAmountWithOperator.vue